/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const getOrganisationMembersDataSchema = z.object({
	perPage: z.number(),
	page: z.number(),
})

export type GetOrganisationMembersDataSchema = z.infer<typeof getOrganisationMembersDataSchema>
